import InfoTab from './infoTab';

export default InfoTab;
